module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-10.c420deac.png";